// =============================================================================
// Timesheet y correcciones (app del trabajador)
// =============================================================================
import { apiClient } from './http';

/** Espejo de DailySummary (backend/app/schemas/punch.py). */
export interface DailySummary {
  date: string;
  weekday_name: string;
  status: string;
  is_workday: boolean;
  first_in: string | null;
  last_out: string | null;
  total_presence_hours: number;
  total_worked_hours: number;
  breaks_paid_minutes: number;
  breaks_unpaid_minutes: number;
  overtime_hours?: number;
}

export async function getTodaySummary(): Promise<DailySummary> {
  const response = await apiClient.get<DailySummary>('/timesheet/today');
  return response.data;
}

/**
 * Espejo de CorrectionCreate (backend/app/schemas/correction.py).
 *
 * Un fichaje NO se edita: se pide una corrección, que es un registro nuevo
 * encadenado al original y que aprueba un responsable.
 */
export interface CorrectionCreate {
  original_punch_id?: number | null;
  correction_date: string;   // YYYY-MM-DD
  // El ENUM `punchtype`: IN/OUT/BREAK_START/BREAK_END. Mandaba el vocabulario
  // del sync y Pydantic devolvía 422 en cada solicitud.
  punch_type: 'IN' | 'OUT' | 'BREAK_START' | 'BREAK_END';
  proposed_time: string;     // HH:MM
  reason: string;            // mínimo 10 caracteres
}

export async function requestCorrection(data: CorrectionCreate): Promise<void> {
  await apiClient.post('/corrections', data);
}
